var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { AddRowComponent } from '../../../../component/addrow/addrow.component';
import { AddRowService } from '../../../../component/addrow/addrow.service';
import { GeneralMaterialData } from './construction-material.service';
var KtsGeneralConstructionMaterialListComponent = /** @class */ (function (_super) {
    __extends(KtsGeneralConstructionMaterialListComponent, _super);
    function KtsGeneralConstructionMaterialListComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.changeMaterial = new EventEmitter();
        _this.generalCols = [];
        _this.materials = [];
        _this.deletedMaterials = [];
        return _this;
    }
    KtsGeneralConstructionMaterialListComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsGeneralConstructionMaterialListComponent.prototype.ngOnChanges = function (changes) {
        if (changes.component) {
            this.primaryKey = jsonpath.value(this.component, '$.params.primaryKey') || '';
        }
        if (changes.generalCols) {
            this.cols = $.extend(true, [], this.generalCols);
        }
        if (changes.materials) {
            var data = {};
            data[this.cols[0].key] = this.materials;
            _super.prototype.onSubscribe.call(this, data);
        }
    };
    KtsGeneralConstructionMaterialListComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        this.cols = $.extend(true, [], this.generalCols);
        this.orgCols = $.extend(true, [], this.cols);
        _super.prototype.checkReadonly.call(this);
    };
    KtsGeneralConstructionMaterialListComponent.prototype.onEvent = function (e1, e2, index) {
        _super.prototype.onEvent.call(this, e1, e2, index);
    };
    KtsGeneralConstructionMaterialListComponent.prototype.setCompRec = function () {
        var items = JSOG.parse(JSON.stringify(this.items));
        for (var i = 0; i < items.length && i < this.materials.length; ++i) {
            this.materials[i].name = items[i].name;
            this.materials[i].special_notes = items[i].special_notes;
            this.materials[i].quantity = items[i].quantity;
            this.materials[i].special_unit = items[i].special_unit;
            this.materials[i].desire_date = items[i].desire_date;
            this.materials[i].order_date = items[i].order_date;
            this.materials[i].delivery_date = items[i].delivery_date;
            this.materials[i].delivery_supplier = items[i].delivery_supplier;
        }
        this.changeMaterial.emit(this.materials);
    };
    KtsGeneralConstructionMaterialListComponent.prototype.onAdd = function (e) {
        this.rec = {};
        this.dispRec = {};
        this.materials.push(new GeneralMaterialData());
        _super.prototype.setRecs.call(this, this.cols[0].items, { $editable: true, $seq: this.seq++ });
        this.items.push(this.rec);
        this.dispItems.push(this.dispRec);
        this.errItems.push({});
        this.addError();
        this.setCompRec();
    };
    KtsGeneralConstructionMaterialListComponent.prototype.onDelete = function (e, index) {
        if (typeof this.items[index][this.primaryKey] !== 'undefined' && this.items[index][this.primaryKey] !== null) {
            this.items[index].$type = "delete" /* Delete */;
            this.deleteItems.push(this.items[index]);
            this.materials[index].$type = "delete" /* Delete */;
            this.deletedMaterials.push(this.materials[index]);
        }
        this.materials.splice(index, 1);
        this.items.splice(index, 1);
        this.dispItems.splice(index, 1);
        this.checkDuplicate();
    };
    KtsGeneralConstructionMaterialListComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-general-construction-material-list',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly || !sortKey\" scope=\"col\"></th>\n        <th [hidden]=\"readonly || !deletable\" scope=\"col\"></th>\n        <th *ngFor=\"let col of cols[0].items\" scope=\"col\">\n          <a a class=\"-fixed\">{{ col.label }}</a>\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"dispItems\" let-index=\"index\">\n        <tr data-href=\"#\">\n          <td [hidden]=\"readonly || !deletable\" class=\"tableWrapper_iconTd\">\n            <a *ngIf=\"item?.$editable\" href=\"javascript:void(0);\" (click)=\"onDelete($event, index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <td *ngFor=\"let col of cols[0].items\">\n            <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n              <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                key: col.key,\n                controlType: col.controlType,\n                dataType: col.dataType,\n                required: col.required,\n                readonly: item.$editable ? col.readonly : true,\n                hidden: col.hidden,\n                params: col.params,\n                items: col.items\n              }\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeRow($event, index)\"></column>\n            </ng-template>\n            <ng-template #elseBlock>\n              <columngroup [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"col\" [val]=\"item\" (changeVal)=\"onChangeRow($event, index)\"></columngroup>\n            </ng-template>\n          </td>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"addable && !readonly && (maxRows === null || dispItems.length < maxRows)\">\n          <button class=\"addBtn\" type=\"button\" (click)=\"onAdd($event, 'add', '')\"></button>\n        </p>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsGeneralConstructionMaterialListComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AddRowService }
    ]; };
    KtsGeneralConstructionMaterialListComponent.propDecorators = {
        changeMaterial: [{ type: Output }],
        generalCols: [{ type: Input }],
        materials: [{ type: Input }],
        deletedMaterials: [{ type: Input }]
    };
    return KtsGeneralConstructionMaterialListComponent;
}(AddRowComponent));
export { KtsGeneralConstructionMaterialListComponent };
//# sourceMappingURL=general-construction-material-list.component.js.map